import React from 'react';

/**
 * 三处二次确认弹框（启用策略 / 保存策略 / 立即执行一次）共享的物理删除警示文案，
 * 避免各自维护一份导致内容漂移。
 */
export function renderPhysicalDeleteWarning(tableName: string, retentionDays: number): React.ReactNode {
  return (
    <div>
      <p>
        将<strong>物理删除</strong> <code>{tableName}</code> 中
        <strong>{retentionDays} 天前</strong>的数据。
      </p>
      <p style={{ color: '#cf1322', marginBottom: 0 }}>
        删除不可恢复，且不会释放磁盘空间（空间会留在表内供后续写入复用）。
      </p>
    </div>
  );
}
